import { StaticPageLoadingPlaceholder } from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { CookiePolicyUi } from './ui';
import { useCookiePolicy } from './useCookiePolicy';

export const CookiePolicy: React.FC = () => {
    const { cmsContent: cookiePolicy, isLoading, loadingError } = useCookiePolicy();

    const CookiePolicyWithHandlers = withLoadingAndNoConnectionHandler(CookiePolicyUi);

    return (
        <CookiePolicyWithHandlers
            isLoading={isLoading}
            cookiePolicy={cookiePolicy}
            hasError={!!loadingError}
            loadingPlaceholder={<StaticPageLoadingPlaceholder />}
        />
    );
};
